
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/energia-solar-fotovoltaica",
      function () {
        return require("private-next-pages/energia-solar-fotovoltaica.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/energia-solar-fotovoltaica"])
      });
    }
  